export default __webpack_public_path__ + "static/media/workflow.f328017b.png";